import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.activate(0)
  }

  switch(event) {
    const index = this.tabTargets.indexOf(event.currentTarget)
    if (index !== -1) this.activate(index)
  }

  activate(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("feature-tab--active", i === index)
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("feature-panel--active", i === index)
    })
  }
}
